import policy from './eventSeoPolicy.js';
export const { eventSeoText, publicEventSeoPolicy } = policy;
